import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LabelWithTooltip from '../../common/components/LabelWithTooltip';
import CollapsablePanel from '../../common/components/CollapsablePanel';
import { ConfirmationButton } from '../../common/components/formControls';
import {
	saveSession, deleteSession, saveWeek, createSession, createWeek, createSessionDate, deleteWeek, cloneDate, cloneWeek,
	WORKSHOP_SESSION_UPDATE_REQUEST, WORKSHOP_SESSION_UPDATE_SUCCESS, WORKSHOP_SESSION_UPDATE_FAILURE,
	WORKSHOP_SESSION_CREATE_REQUEST, WORKSHOP_SESSION_CREATE_SUCCESS, WORKSHOP_SESSION_CREATE_FAILURE,
	WORKSHOP_SESSION_CREATE_DATE_REQUEST, WORKSHOP_SESSION_CREATE_DATE_SUCCESS, WORKSHOP_SESSION_CREATE_DATE_FAILURE,
	WORKSHOP_WEEK_UPDATE_REQUEST, WORKSHOP_WEEK_UPDATE_SUCCESS, WORKSHOP_WEEK_UPDATE_FAILURE,
	WORKSHOP_WEEK_CREATE_REQUEST, WORKSHOP_WEEK_CREATE_SUCCESS, WORKSHOP_WEEK_CREATE_FAILURE,
	WORKSHOP_CLONE_DATE_REQUEST, WORKSHOP_CLONE_DATE_SUCCESS, WORKSHOP_CLONE_DATE_FAILURE,
	WORKSHOP_CLONE_WEEK_REQUEST, WORKSHOP_CLONE_WEEK_SUCCESS, WORKSHOP_CLONE_WEEK_FAILURE,
	WorkshopSessionTimes
} from './actions';
import SessionDialog from './SessionDialog';
import NewSessionDateDialog from './NewSessionDateDialog';
import WeekDialog from './WeekDialog';
import CloneDateDialog from './CloneDateDialog';
import CloneWeekDialog from './CloneWeekDialog';
import { faCalendar, faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { faPlus, faTrash, faTriangleExclamation, faUsers, faCopy } from '@fortawesome/free-solid-svg-icons';

const WorkshopSessionTypes = {
	Morning: 1,
	Afternoon: 2,
	FullDay: 3
}

class Sessions extends Component {
	constructor(props) {
		super(props);
		this.handleDelete = this.handleDelete.bind(this);
		this.showSessionDialog = this.showSessionDialog.bind(this);
		this.hideSessionDialog = this.hideSessionDialog.bind(this);
		this.handleSaveSession = this.handleSaveSession.bind(this);
		this.showNewSessionDateDialog = this.showNewSessionDateDialog.bind(this);
		this.hideNewSessionDateDialog = this.hideNewSessionDateDialog.bind(this);
		this.handleSaveNewSessionDate = this.handleSaveNewSessionDate.bind(this);
		this.showWeekDialog = this.showWeekDialog.bind(this);
		this.hideWeekDialog = this.hideWeekDialog.bind(this);
		this.handleSaveWeek = this.handleSaveWeek.bind(this);
		this.showCloneDateDialog = this.showCloneDateDialog.bind(this);
		this.hideCloneDateDialog = this.hideCloneDateDialog.bind(this);
		this.handleCloneDate = this.handleCloneDate.bind(this);
		this.showCloneWeekDialog = this.showCloneWeekDialog.bind(this);
		this.hideCloneWeekDialog = this.hideCloneWeekDialog.bind(this);
		this.handleCloneWeek = this.handleCloneWeek.bind(this);

		this.state = {
			showSessionDialog: false,
			showNewSessionDateDialog: false,
			showWeekDialog: false,
			showCloneDateDialog: false,
			showCloneWeekDialog: false
		};
	}

	handleDelete(sessionId) {
		const { deleteSession } = this.props;
		deleteSession(sessionId, () => this.hideSessionDialog())
	}

	showSessionDialog(session) {
		this.setState({
			showSessionDialog: true,
			selectedSession: session
		});
	}

	hideSessionDialog() {
		this.setState({
			showSessionDialog: false
		});
	}

	handleSaveSession(values) {
		const { saveSession, createSession } = this.props;
		if (values.id) {
			saveSession(this.state.selectedSession.id, values, () => this.hideSessionDialog());
		}
		else {
			createSession(values, () => this.hideSessionDialog());
		}
	}

	showNewSessionDateDialog(weekId) {
		this.setState({
			showNewSessionDateDialog: true,
			selectedWeekId: weekId
		});
	}

	hideNewSessionDateDialog() {
		this.setState({
			showNewSessionDateDialog: false
		});
	}

	handleSaveNewSessionDate(values) {
		const { createSessionDate } = this.props;
		createSessionDate(values, () => this.hideNewSessionDateDialog());
	}

	showWeekDialog(week) {
		this.setState({
			showWeekDialog: true,
			selectedWeek: week
		});
	}

	hideWeekDialog() {
		this.setState({
			showWeekDialog: false
		});
	}

	handleSaveWeek(values) {
		const { saveWeek, workshopId, createWeek } = this.props;
		if (this.state.selectedWeek) {
			saveWeek(this.state.selectedWeek.id, values, () => this.hideWeekDialog());
		}
		else {
			createWeek({ workshopId: workshopId, ...values }, () => this.hideWeekDialog())
		}
	}

	showCloneDateDialog(weekId, date) {
		this.setState({
			showCloneDateDialog: true,
			selectedWeekId: weekId,
			selectedDate: date

		});
	}

	hideCloneDateDialog() {
		this.setState({
			showCloneDateDialog: false
		});
	}

	handleCloneDate(values) {
		const { cloneDate } = this.props;
		cloneDate(values, () => this.hideCloneDateDialog());
	}

	showCloneWeekDialog(week) {
		this.setState({
			showCloneWeekDialog: true,
			selectedWeek: week
		});
	}

	hideCloneWeekDialog() {
		this.setState({
			showCloneWeekDialog: false
		});
	}

	handleCloneWeek(values) {
		const { cloneWeek } = this.props;
		cloneWeek(values, () => this.hideCloneWeekDialog());
	}

	renderButtons(session) {
		const { t } = this.props;
		const editButton = <Button onClick={() => this.showSessionDialog(session)} className='btn btn-teal'
			style={{ marginRight: '10px' }}><FontAwesomeIcon icon={faPenToSquare} /> {t('Common_Edit')}
		</Button>

		return [editButton]
	}

	renderWeekTitle(week) {
		const { isReadonly, deleteWeek, workshop, t } = this.props;
		const editButton = !isReadonly && <a onClick={() => this.showWeekDialog(week)} title='Edit' style={{ marginLeft: '10px', cursor: 'pointer' }}>
			<FontAwesomeIcon icon={faPenToSquare} />
		</a>
		const deleteButton = !isReadonly && week && !week.startDate && !week.endDate &&
			<ConfirmationButton style={{ marginLeft: '10px' }} title='Delete'
				onConfirmation={() => deleteWeek(week.id)}
				confirmationTitle={t('Workshop_Week_DeleteConfirmationTitle')}
				confirmationMessage={t('Workshop_Week_DeleteConfirmationMessage')}
				displayType='inline'
				icon={faTrash}
				showLink={true}
				iconStyle={{ color: 'red' }}
			/>;
		const attendanceButton = <Link title='Attendance' to={`/workshopAttendance/workshop/${week.workshopId}/week/${week.id}`} style={{ marginLeft: '10px' }}>
			<FontAwesomeIcon icon={faCalendar} />
		</Link>;
		const cloneWeekButton = !isReadonly && week && <a onClick={() => this.showCloneWeekDialog(week)} style={{ marginLeft: '10px', cursor: 'pointer' }} title={t('WorkshopSession_CloneWeek_Tooltip')}>
				<FontAwesomeIcon icon={faCopy} />
		</a>
		return [
			<span style={{ fontWeight: 'bold' }}>{`${workshop && workshop.name || ''} - ${week.name}`}</span>,
			<span> {week.startDate && week.endDate && `(${ui.formatDate(week.startDate)} - ${ui.formatDate(week.endDate)})`}</span>,
			editButton,
			attendanceButton,
			deleteButton,
			cloneWeekButton
		];
	}

	getSessionDates(weekSessions) {
		return [...new Set(weekSessions.map(item => item.date))];
	}

	renderSessionButton(weekSessions, date, sessionType, weekId) {
		const { isReadonly, t } = this.props;
		const session = weekSessions.find(s => s.date === date && s.typeId === sessionType);
		const newSessionTitle = sessionType === WorkshopSessionTypes.Morning ? t('Workshop_Add_MorningSession') :
			(sessionType === WorkshopSessionTypes.Afternoon ? t('Workshop_Add_AfternoonSession') : t('Workshop_Add_FullDaySession'));
		return session ? <a onClick={() => this.showSessionDialog(session)} className='btn btn-teal' style={{ width: '100%' }}>
			<FontAwesomeIcon icon={faPenToSquare} /> {session.typeName}: {ui.formatTime(session.startTime)} - {ui.formatTime(session.endTime)}
			<FontAwesomeIcon style={{ marginLeft: '10px' }} icon={faUsers} /> {session.actualCapacity} {sessionType === 3 && this.capacityWarning(weekSessions, date)}
		</a> : (!isReadonly ? <Button onClick={() => this.showSessionDialog(
			{
				weekId: weekId,
				date: date,
				typeId: sessionType,
				typeName: t(`WorkshopSessionType_${sessionType === WorkshopSessionTypes.Morning ? 'Morning' : sessionType === WorkshopSessionTypes.Afternoon ? 'Afternoon' : 'FullDay'}`),
				startTime: ui.adjustDate(sessionType === WorkshopSessionTypes.Morning || sessionType === WorkshopSessionTypes.FullDay ? WorkshopSessionTimes.MorningStartTime : WorkshopSessionTimes.AfternoonStartTime, 0, 0),
				endTime: ui.adjustDate(sessionType === WorkshopSessionTypes.Morning ? WorkshopSessionTimes.MorningEndTime : WorkshopSessionTimes.AfternoonEndTime, 0, 0)
			})}
				className='btn btn-success' style={{ width: '100%' }}> <FontAwesomeIcon icon={faPlus} /> {newSessionTitle}</Button> : '')
	}

	capacityWarning(weekSessions, date) {
		const { t } = this.props;
		const fullDaySessionOnDate = weekSessions.find(s => s.date === date && s.typeId === 3);
		const morningSessionOnDate = weekSessions.find(s => s.date === date && s.typeId === 1);
		const afternoonSessionOnDate = weekSessions.find(s => s.date === date && s.typeId === 2);
		let showWarning = fullDaySessionOnDate && morningSessionOnDate && afternoonSessionOnDate &&
			fullDaySessionOnDate.actualCapacity !== (morningSessionOnDate.actualCapacity < afternoonSessionOnDate.actualCapacity ? morningSessionOnDate.actualCapacity : afternoonSessionOnDate.actualCapacity) ||
			fullDaySessionOnDate && morningSessionOnDate && !afternoonSessionOnDate && fullDaySessionOnDate.actualCapacity > morningSessionOnDate.actualCapacity ||
			fullDaySessionOnDate && afternoonSessionOnDate && !morningSessionOnDate && fullDaySessionOnDate.actualCapacity > afternoonSessionOnDate.actualCapacity;
		return showWarning ?
			<LabelWithTooltip id='capacityWarning' placement='left'
				tooltip={t(morningSessionOnDate && afternoonSessionOnDate ? 'WorkshopSession_CapacityWarning' : 'WorkshopSession_CapacityWarningOnlyOneHalfDaySession')}>
				<FontAwesomeIcon style={{ color: 'yellow', marginLeft: '5px' }} icon={faTriangleExclamation} />
			</LabelWithTooltip> : ''
	}

	render() {
		const { isReadonly, weeks, workshopSessionTypes, t } = this.props;

		return <React.Fragment>
			{!isReadonly && <Row style={{ padding: '0 16px', marginBottom: '10px' }}>
				<div className='pull-right'>
					<Button onClick={() => this.showWeekDialog()} className='btn btn-success' >
						<FontAwesomeIcon icon={faPlus} /> <span>{t('Workshop_Add_Week')}</span>
					</Button>
				</div>
			</Row>}
			{weeks.map(w => <div key={w.id}>
				<CollapsablePanel title={this.renderWeekTitle(w)}>
					{<React.Fragment>
						{!isReadonly &&
							<div className='pull-right' style={{ marginBottom: '10px' }}>
								<Button onClick={() => this.showNewSessionDateDialog(w.id)} className='btn btn-success' >
									<FontAwesomeIcon icon={faPlus} /> {t('Workshop_Add_Date')}
								</Button>
							</div>
						}
						<Table>
							<tbody>
								{this.getSessionDates(w.sessions).map(date => (
									<tr key={date}>
										<td>{moment(date).format('LL, dddd')}</td>
										<td><a onClick={() => this.showCloneDateDialog(w.id, date)} style={{ cursor: 'pointer' }} title={t('WorkshopSession_CloneDate_Tooltip')}>
											<FontAwesomeIcon icon={faCopy} /></a>
										</td>
										<td>
											<Row>
												<Col sm={4}> {this.renderSessionButton(w.sessions, date, 1, w.id)}</Col>
												<Col sm={4}> {this.renderSessionButton(w.sessions, date, 2, w.id)}</Col>
												<Col sm={4}> {this.renderSessionButton(w.sessions, date, 3, w.id)}</Col>
											</Row>
										</td>
									</tr>
								))}
							</tbody>
						</Table>
					</React.Fragment>}
				</CollapsablePanel>
			</div>)}
			<SessionDialog
				session={this.state.selectedSession}
				workshopSessionTypes={workshopSessionTypes}
				show={this.state.showSessionDialog}
				onConfirm={this.handleSaveSession}
				onDelete={this.handleDelete}
				onCancel={this.hideSessionDialog}
				isReadonly={isReadonly}
				block={[WORKSHOP_SESSION_UPDATE_REQUEST, WORKSHOP_SESSION_CREATE_REQUEST]}
				unblock={[WORKSHOP_SESSION_UPDATE_SUCCESS, WORKSHOP_SESSION_UPDATE_FAILURE,
					WORKSHOP_SESSION_CREATE_SUCCESS, WORKSHOP_SESSION_CREATE_FAILURE]}
			/>
			<NewSessionDateDialog
				weekId={this.state.selectedWeekId}
				show={this.state.showNewSessionDateDialog}
				onConfirm={this.handleSaveNewSessionDate}
				onCancel={this.hideNewSessionDateDialog}
				block={[WORKSHOP_SESSION_CREATE_DATE_REQUEST]}
				unblock={[WORKSHOP_SESSION_CREATE_DATE_SUCCESS, WORKSHOP_SESSION_CREATE_DATE_FAILURE]} />
			<WeekDialog
				week={this.state.selectedWeek}
				show={this.state.showWeekDialog}
				onConfirm={this.handleSaveWeek}
				onCancel={this.hideWeekDialog}
				block={WORKSHOP_WEEK_UPDATE_REQUEST, WORKSHOP_WEEK_CREATE_REQUEST}
				unblock={[WORKSHOP_WEEK_UPDATE_SUCCESS, WORKSHOP_WEEK_UPDATE_FAILURE, WORKSHOP_WEEK_CREATE_SUCCESS, WORKSHOP_WEEK_CREATE_FAILURE]} />
			<CloneDateDialog
				weekId={this.state.selectedWeekId}
				sourceDate={this.state.selectedDate}
				show={this.state.showCloneDateDialog}
				onConfirm={this.handleCloneDate}
				onCancel={this.hideCloneDateDialog}
				block={[WORKSHOP_CLONE_DATE_REQUEST]}
				unblock={[WORKSHOP_CLONE_DATE_SUCCESS, WORKSHOP_CLONE_DATE_FAILURE]} />
			<CloneWeekDialog
				week={this.state.selectedWeek}
				show={this.state.showCloneWeekDialog}
				onConfirm={this.handleCloneWeek}
				onCancel={this.hideCloneWeekDialog}
				block={[WORKSHOP_CLONE_WEEK_REQUEST]}
				unblock={[WORKSHOP_CLONE_WEEK_SUCCESS, WORKSHOP_CLONE_WEEK_FAILURE]} />
		</React.Fragment>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const workshopId = ownProps.workshopId;
	const {
		entities: { workshops },
		lookups: { workshopSessionTypes }
	} = state;

	const workshop = workshops[workshopId];
	return {
		workshop,
		weeks: workshop && workshop.weeks,
		workshopId,
		workshopSessionTypes
	};
};
Sessions.propTypes = {
	workshopId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, {
	saveSession,
	createSession,
	deleteSession,
	createWeek,
	saveWeek,
	createSessionDate,
	deleteWeek,
	cloneDate,
	cloneWeek
})(withTranslation()(Sessions));